import type {LayoutSettings} from './types';

export const defaultViewLayoutSettings: LayoutSettings = {
    defaultRowWidth: 'default',
    rowGap: '30px',
    columnGap: '30px',
    mainLayoutGap: '30px'
};